import { NgModule } from '@angular/core';
import { FiHomeComponent } from './home.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { FiStartPageLayoutModule } from '@fi-app/components/start-page-layout/start-page-layout.module';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { UIRouterModule } from '@uirouter/angular';
import { FiHomeStates } from '@fi-app/home/home-states';
import { FiModuleStateComponent } from '@fi-app/home/states/home-state';
@NgModule({
    imports: [
        UtilitiesModule,
        FiWhenScrolledModule,
        FiStartPageLayoutModule,
        UIRouterModule.forChild(FiHomeStates),
    ],
    declarations: [FiHomeComponent, FiModuleStateComponent],
    exports: [FiHomeComponent],
})
export class FiHomeModule {}
